/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading colleague…" |
*
* @param {Colleague_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const colleague_loading = /** @type {((inputs?: Colleague_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Collega laden…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du collègue…")
	return /** @type {LocalizedString} */ ("Loading colleague…")
});